<app-custom-table [showRecover]="true" [showCheckbox]="true" [isMultipleSelect]="true" [data]="data" [headers]="columns"
  [checkBoxAction]="checkboxActions" [previousFilters]="filters" (onPageChange)="onPageChange($event)"
  (onAction)="onAction($event)" (onRecoverData)="getMaintenanceActivitiesForSelection()"
  (onFilterChange)="onFilterChange($event)">
</app-custom-table>